import { Howl, Howler } from "howler";

let bgMusic: Howl;
let godRay: Howl;
let uiButton: Howl;
let popup: Howl;

enum SoundEffects {
  GodRay = 0,
  UIButton = 1,
  Popup = 2
}

function create() {}

function awake() {
  destroy();

  bgMusic = new Howl({
    src: ["/assets/audio/bg.mp3"],
    volume: 0.5,
    autoplay: true,
    loop: true
  });

  godRay = new Howl({
    src: ["/assets/audio/godray.mp3"],
    volume: 1
  });

  popup = new Howl({
    src: ["/assets/audio/popup.mp3"],
    volume: 1
  });

  uiButton = new Howl({
    src: ["/assets/audio/ui-button.mp3"],
    volume: 1
  });
}

function destroy() {
  Howler.unload();
}

function tick() {}

function playSFX(effect: SoundEffects) {
  switch (effect) {
    case SoundEffects.GodRay:
      godRay.play();
      break;
    case SoundEffects.UIButton:
      uiButton.play();
      break;
    case SoundEffects.Popup:
      popup.play();
      break;
  }
}

export { awake, create, destroy, tick, playSFX, SoundEffects };
